export const MESSAGES = {
	CONFIRM_ACTION: 'Are you sure you want to {$}?',
	CONFIRM_CREATE: 'Are you sure you want to create this {$1}?',
	CONFIRM_UPDATE: 'Are you sure you want to update this {$1}?',
	CONFIRM_DELETE: 'Are you sure you want to delete this {$1}?',
	CONFIRM_ASSIGN_SHIFT: 'Are you sure you want to assign this shift schedule to this employee?',
	CONFIRM_CANCEL: 'Are you sure want to cancel this {$1}?',
	CONFIRM_APPROVE: 'Are you sure you want to approve this {$1}?',
	CONFIRM_DENY: 'Are you sure you want to deny this {$1}?',
	CONFIRM_SUBMIT: 'Are you sure you want to submit this {$1}?',
	CONFIRM_GENERIC: 'Are you sure you want to {$1}?',
	SUCCESS_CREATE: '{$1} has been successfully created.',
	SUCCESS_FILE: '{$1} successfully filed.',
	SUCCESS_UPDATE: '{$1} has been successfully updated.',
	SUCCESS_DELETE: '{$1} has been successfully deleted.',
	SUCCESS_CANCEL: '{$1} has been successfully cancelled.',
	SUCCESS_RETRACT: '{$1} successfully retracted.',
	SUCCESS_EMPLOYEE_SHIFT_ASSIGNMENT: 'Shift schedule has been assigned to employee.',
	SUCCESS_GENERIC: 'Successfully {$1} {$2}.',
	NO_DATA_FOUND: 'No Data Found.',
	NO_PERMISSIONS_MSG: 'You do not have the permission to view this module.',

	NO_ITEMS_FOUND: (item: string) => `No ${item} found.`,
};

export const FIELD_ERRORS = {
	maxLength: 'Maximum of 250 characters are allowed.',
}